(function () {
  if (window.kcWaitlist) return;
  window.kcWaitlist = true;

  var KEY = 'kcWaitlist';
  function save(v) { try { sessionStorage.setItem(KEY, v); } catch (e) {} }
  function take() {
    var v = null;
    try { v = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch (e) {}
    return v;
  }

  function pick(wrap, size) {
    var sel = wrap.querySelector('select');
    if (!sel) return;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === size) { sel.selectedIndex = i; break; }
    }
  }

  // Remember which waitlist was sent, so the right one says thanks after the reload.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('kc-wl__form')) return;
    var wrap = form.closest('.kc-wl');
    if (wrap && wrap.id) save(wrap.id);
  }, true);

  // Product page: the waitlist follows the size picker.
  // A sold out size shows it, open, with that size picked. An in stock size hides it again.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.kc-size-opt') : null;
    if (!btn) return;
    var product = btn.closest('.kc-product');
    var wrap = product ? product.querySelector('.kc-wl') : null;
    if (!wrap) return;
    if (btn.getAttribute('data-available') === 'false') {
      pick(wrap, btn.getAttribute('data-value'));
      wrap.hidden = false;
      wrap.open = true;
      try { wrap.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (err) {}
    } else if (wrap.hasAttribute('data-kc-follow')) {
      wrap.hidden = true;
    }
  });

  function ready() {
    // If the page opens on a sold out size, show the waitlist for it.
    var follow = document.querySelectorAll('.kc-product .kc-wl[data-kc-follow]');
    for (var i = 0; i < follow.length; i++) {
      var on = follow[i].closest('.kc-product').querySelector('.kc-size-opt[aria-checked="true"]');
      if (on && on.getAttribute('data-available') === 'false') {
        pick(follow[i], on.getAttribute('data-value'));
        follow[i].hidden = false;
      }
    }

    var saved = take();
    if (!/[?&]contact_posted=true/.test(location.search)) return;
    var wrap = saved ? document.getElementById(saved) : null;
    if (!wrap && location.hash) {
      var target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (target) wrap = target.closest('.kc-wl');
    }
    if (!wrap) return;
    wrap.hidden = false;
    wrap.open = true;
    ['.kc-wl__toggle', '.kc-wl__form'].forEach(function (sel) {
      var el = wrap.querySelector(sel);
      if (el) el.hidden = true;
    });
    var msg = wrap.querySelector('.kc-wl__msg');
    if (msg) msg.hidden = false;
    try { wrap.scrollIntoView({ block: 'center' }); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();